@app.directive 'specialTerms', (ModalService)->
  restrict: 'E'
  scope: {}
  controller: ($scope) ->
    @params = ModalService.params()

    @close = ->
      ModalService.resolve()

    this

  controllerAs: 'specialTerms'
  templateUrl: "/assets/templates/modals/specialTerms/specialTerms.html"
